/**
 * 受付エラー更新API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 受付情報
 */
export interface Sgkb983aResAceptInfoDto {
    /**
     * 受付番号
     */
    aceptNo?: string;
    /**
     * 受付履歴番号
     */
    aceptRrkno?: string;
    /**
     * 更新通番号
     */
    updateSrno?: string;
    /**
     * 受付ステータス
     */
    aceptSts?: string;
}

